/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { QueryWrapperNext } from '@diamond/shared/data-access';
import { ProductFilter } from '@diamond/shared/types';

import { useAuthStore } from '../stores';

export const useBrowseProductData = () => {
  const session = useAuthStore();

  const queryProductFilter = QueryWrapperNext(
    '/product/filters',
    session.access_token
  );

  const { data: productFilter, isLoading: isLoadingProductFilter } =
    queryProductFilter.useQueryGet<ProductFilter>('ProductFilter');

  const productFilterData = productFilter as ProductFilter;

  const divisionData = productFilterData.divisions?.map((val) => {
    return {
      label: val.name,
      value: val.divisi_code,
    };
  });

  const storagesData = productFilterData.storages?.map((val) => {
    return {
      label: val.name,
      value: val.storage_code,
    };
  });

  const sortsData = productFilterData.sorts?.map((val) => {
    return {
      label: val.name,
      value: val.sort_by_code,
    };
  });

  return {
    divisionData,
    storagesData,
    sortsData,
    isLoadingProductFilter,
  };
};

export default useBrowseProductData;
